<template>
  <div>
    <el-radio-group class="el-radio-group" :value="alibabaForm[key]" @change.native="onChange">
      <el-radio v-for="item in options" :label="item.value" :key="item.value" :disabled="item.disabled"
        >{{ item.displayName }}
        <el-tooltip v-if="item.warning" class="item" effect="dark" :content="item.warning" placement="top">
          <i style="margin-left: 5px; margin-right: 5px" class="el-icon-warning" />
        </el-tooltip>
        <span class="tips ft-12" v-if="item.tipText"> {{ item.tipText }}</span>
      </el-radio>
    </el-radio-group>

    <date-picker-erp
      v-if="showDate"
      :value="dataValue"
      placeholder="选择日期时间"
      time-type="datetime"
      value-format="YYYY-MM-DD HH:mm:ss"
      :min-time="minTime"
      style="margin-left: 10px; display: inline-block"
      @change="dateChange"
    ></date-picker-erp>
  </div>
</template>

<script>
import storeMixins from '../store-mixins';
import dayjs from 'dayjs';
export default {
  mixins: [storeMixins],
  props: ['props', 'isSizeGroup'],
  data() {
    return {
      isHasOptionsComp: true,
      minTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    };
  },
  computed: {
    key() {
      return this.props.name;
    },
    defaultValue() {
      return this.props.dataSource.defaultValue;
    },
    showDate() {
      return this.key === 'upshelfTime' && this.alibabaForm?.upshelfTime === '2';
    },
    dataValue() {
      return { start: this.alibabaForm.upshelfTime_date || '' };
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {};
      newFormFields[this.key] = v.target.value;
      this.updateAlibabaForm(newFormFields);
    },
    dateChange(v) {
      this.updateAlibabaForm({ upshelfTime_date: v.start });
    },
  },
  updated() {
    const value = this.alibabaForm[this.key] || '';
    const isFind = this.options.some(item => item.value === value);

    if (!isFind && value) {
      let newValue = '';

      if (this.isSizeGroup) {
        const commonSize = this.options.find(item => ['通用', '均码'].includes(item.displayName)) || this.options[0];
        if (commonSize) {
          newValue = commonSize.value;
        }
      }

      this.onChange({ target: { value: newValue } });
    }
  },
};
</script>

<style lang="scss" scoped>
.el-radio-group {
.tips {
    color: #ff7300;
  }
}
</style>